import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { testCaseAPI } from '../services/api';

function TestCasesList() {
  const [testCases, setTestCases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState('');

  useEffect(() => {
    fetchProjects();
    fetchTestCases();
  }, [selectedProject]);

  const fetchProjects = async () => {
    try {
      const response = await testCaseAPI.getProjects();
      setProjects(response.data);
    } catch (err) {
      console.error('Failed to fetch projects:', err);
    }
  };

  const fetchTestCases = async () => {
    try {
      setLoading(true);
      const response = await testCaseAPI.getAll(selectedProject);
      setTestCases(response.data);
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this test case?')) {
      return;
    }

    try {
      await testCaseAPI.delete(id);
      fetchTestCases();
    } catch (err) {
      alert('Failed to delete test case: ' + err.message);
    }
  };

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div>
      <div className="card">
        <div className="flex-between mb-3">
          <h2>Test Cases</h2>
          <Link to="/create" className="btn btn-primary">
            Create New Test Case
          </Link>
        </div>

        <div className="form-group">
          <label>Filter by Project</label>
          <select
            value={selectedProject}
            onChange={(e) => setSelectedProject(e.target.value)}
          >
            <option value="">All Projects</option>
            {projects.map(project => (
              <option key={project} value={project}>{project}</option>
            ))}
          </select>
        </div>

        {error && (
          <div className="alert alert-danger">{error}</div>
        )}

        {testCases.length === 0 ? (
          <div className="text-center mt-3">
            <p>No test cases found. Create your first test case to get started!</p>
          </div>
        ) : (
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Project</th>
                <th>Endpoint</th>
                <th>Method</th>
                <th>Total Tests</th>
                <th>Created</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {testCases.map(testCase => (
                <tr key={testCase._id}>
                  <td>
                    <Link to={`/test-case/${testCase._id}`}>
                      {testCase.name}
                    </Link>
                  </td>
                  <td>{testCase.project}</td>
                  <td style={{ fontSize: '0.875rem' }}>{testCase.endpoint}</td>
                  <td>
                    <span className="badge badge-info">{testCase.method}</span>
                  </td>
                  <td>{testCase.totalTests || testCase.tests?.length || 0}</td>
                  <td>{new Date(testCase.createdAt).toLocaleDateString()}</td>
                  <td>
                    <div className="flex">
                      <Link
                        to={`/execute/${testCase._id}`}
                        className="btn btn-success"
                        style={{ padding: '0.5rem 1rem' }}
                      >
                        Run
                      </Link>
                      <button
                        onClick={() => handleDelete(testCase._id)}
                        className="btn btn-danger"
                        style={{ padding: '0.5rem 1rem' }}
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default TestCasesList;
